// extracted by mini-css-extract-plugin
export default {"scroll-progress":"ScrollProgress_scroll-progress__XPbZX","progress":"ScrollProgress_progress__p9GQi"};